import CompareButton from './CompareButton';

export default CompareButton;
